import { render, staticRenderFns } from "./c-tabs@.vue?vue&type=template&id=39bf36b0&"
import script from "./c-tabs@.vue?vue&type=script&lang=ts&"
export * from "./c-tabs@.vue?vue&type=script&lang=ts&"
import style0 from "./c-tabs@.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports